module.exports = __webpack_public_path__ + "img/empty-single-library.e3707d31.gif";